import {Navigable} from '@synako/halitrek';
import {useHalState} from '@synako/haligator';
import {ClientDesc} from 'api-types/ffconnect-hal';

export const useTotalPaniers = (client: Navigable<ClientDesc>): number => {
  const clientState = useHalState(client);
  return clientState.data?.nombre_paniers_ouverts_utilisateur ?? 0;
};
